import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ReportsCommonService } from 'app/modules/reports/services/reports-common.service';
import { ReportsEstudioService } from 'app/modules/reports/services/reports-estudio.service';

@Component({
    selector: 'app-popup-view',
    templateUrl: './popup-view.component.html',
    styleUrls: ['./popup-view.component.scss'],
    standalone: false
})
export class PopupViewComponent implements OnInit {

  public modalTitle: string;
  public reportAttributeList: any[];

  constructor(public dialogRef: MatDialogRef<PopupViewComponent>,
              public reportCommonService: ReportsCommonService,
              public reportEstudioService: ReportsEstudioService) { }

  ngOnInit(): void {
    this.modalTitle = 'Attributos';
  }

  SetAttribute(attributeList: any[]): void {
    this.reportAttributeList = attributeList;
  }

  addAttribute(): void {   
    this.reportCommonService.refreshEstudioReportElements();
    this.dialogRef.close();
  }

  closePopup(): void {
    this.reportCommonService.refreshSelectedAttributeIds();
    this.dialogRef.close();
  }

}
